import {AgentIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import type {FC} from 'react'

interface FindingsFilterBarProps {
  displayedCount: number
  handleFix: () => void
}

export const FindingsFilterBar: FC<FindingsFilterBarProps> = ({displayedCount, handleFix}) => {
  return (
    <div className="d-flex flex-items-center flex-justify-between tmp-mb-3">
      <h2 id="findings-heading" className="f4">
        Findings
      </h2>
      <Button
        size="small"
        variant="primary"
        leadingVisual={AgentIcon}
        onClick={handleFix}
        disabled={displayedCount === 0}
      >
        Fix with Copilot
      </Button>
    </div>
  )
}
